import getAPIUrl from './get-api-url';
import getSupportedLocales from './get-supported-locales';

export default {
  getAPIUrl,
  getSupportedLocales,
};
